import { useState, useEffect } from 'react'
import { RefreshCw } from 'lucide-react'

/**
 * Componente che mostra l'ultimo aggiornamento
 * 
 * @param {Date} timestamp - Data ultimo aggiornamento
 * @param {Function} onRefresh - Funzione di refresh manuale
 */
export function LastUpdated({ timestamp, onRefresh, className = '' }) {
  const [timeAgo, setTimeAgo] = useState('')

  useEffect(() => {
    if (!timestamp) return

    const updateTimeAgo = () => {
      const seconds = Math.floor((Date.now() - timestamp.getTime()) / 1000)
      
      if (seconds < 5) {
        setTimeAgo('adesso')
      } else if (seconds < 60) {
        setTimeAgo(`${seconds} sec fa`)
      } else if (seconds < 3600) {
        const minutes = Math.floor(seconds / 60)
        setTimeAgo(`${minutes} min fa`)
      } else {
        const hours = Math.floor(seconds / 3600)
        setTimeAgo(`${hours} ore fa`)
      }
    }

    updateTimeAgo()
    const interval = setInterval(updateTimeAgo, 5000)

    return () => clearInterval(interval)
  }, [timestamp])

  if (!timestamp) return null

  return (
    <div className={`flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400 ${className}`}>
      <RefreshCw className="h-3 w-3" />
      <span>Aggiornato {timeAgo}</span>
      {onRefresh && (
        <button
          onClick={onRefresh}
          className="text-primary-600 hover:text-primary-700 font-medium"
        >
          Aggiorna
        </button>
      )}
    </div>
  )
}

export default LastUpdated
